import { filter, find, go, html, last, pluck, sel, strMap } from 'fxjs/es';
import $dataStr from 'fxdom/es/dataStr.js';
import { checkedBox, questionMark, unCheckedBox } from '../../../OMP/Core/Atom/S/Tmpl/icon.js';
import { BpOptionUploadTypeS } from '../../UploadType/S/Function/module/BpOptionUploadTypeS.js';
import { BpOptionConstantS } from '../Constant/module/BpOptionConstantS.js';
import { BpOptionS } from '../Function/module/BpOptionS.js';
import { VectorEditorConstantS } from '../../../VectorEditor/S/Constant/module/VectorEditorConstantS.js';
import { LinkToInput } from '@modules/NewMaker/UI/LinkToInput/LinkToInput.ts';
import { OPTION_ID_SIZE_20X20_MM } from '@modules/BpOption/S/Constant/bpoption.js';
import { UtilS } from '@modules/Util/S/Function/module/UtilS.js';

const makeQuestionMark = (bp_option_group) =>
  html`<span
    class="question_mark"
    data-additional_information_type="${bp_option_group.additional_information.type}"
    data-fx-json="${$dataStr(bp_option_group.additional_information)}"
    >${questionMark()}</span
  >`;

export const nfcInputHtml = (is_mobile, bp_option_group) => {
  return html`<span class="nfc_option_group_name"
      ><img
        src="//s3.marpple.co/files/u_2798351/2025/8/original/46b9db6233043d1f4d209a77ca1ef6fd1129c0a31.png"
        alt="nfc_image"
      />
      ${bp_option_group['name' + G._en]}
    </span>
    <div class="additional-information">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="4"
        height="4"
        viewBox="0 0 4 4"
        fill="none"
        style="margin-bottom: 16px;"
      >
        <circle cx="2" cy="2" r="2" fill="${G.collabo_type == '' ? '#FF6B00' : '#1C75FF'}" />
      </svg>
    </div>`;
};
export const additionalInfoHtml = (is_mobile, bp_option_group) => {
  return html`<span> ${bp_option_group['name' + G._en]} </span>
    <div class="additional-information">${makeQuestionMark(bp_option_group)}</div>`;
};

const makeCheckBoxTypeHtml = (bp_option_group, bp_options, selected_bp_option_id) => {
  const is_checked = go(
    bp_options,
    find(({ id }) => id === selected_bp_option_id),
    (option) => option.no === 1,
  );
  return html`
    <label class="bp_checkbox_option" data-is_checked=${is_checked}>
      ${is_checked ? checkedBox() : unCheckedBox()} ${bp_option_group['name' + G._en]}
    </label>
    ${bp_option_group.additional_information !== null ? makeQuestionMark(bp_option_group) : ''}
  `;
};

const setDisable = (is_disabled, is_designed, is_lockable) => {
  return is_disabled || (is_designed && is_lockable);
};

const bpOptionGroupsHtmlArr = ({
  selected_bp_option_id,
  base_products_bp_option_group,
  bp_option_group,
  bp_options,
  is_designed,
  is_mobile,
  is_vector_editor,
  flexi_size,
  is_custom_editor,
  nfc_info,
}) => {
  const { can_change, default_bp_option_id } = base_products_bp_option_group;
  const { is_visibility, is_name, is_virtual, name, name_en, name_jp, dev_name, id } = bp_option_group;
  let { is_lockable } = bp_option_group;
  if (bp_option_group.id == BpOptionUploadTypeS.UPLOAD_TYPE.bp_option_group_id && is_vector_editor) {
    is_lockable = true;
  }

  let is_disabled;

  return html`
    <div
      class="bp_option_group"
      data-id="${id}"
      data-_default_bp_option_id="${default_bp_option_id}"
      data-is_lockable="${is_lockable}"
      data-dev_name="${dev_name}"
      data-is_virtual="${is_virtual}"
      data-is_name="${is_name}"
      data-can_change="${can_change}"
      data-is_visibility="${is_visibility}"
      data-name="${name}"
      data-name_en="${name_en}"
      data-name_jp="${name_jp}"
      data-ui_type_pc="${bp_option_group.ui_type_pc}"
      data-ui_type_mobile="${bp_option_group.ui_type_mobile}"
      data-additonal_information="${$dataStr(bp_option_group?.additional_information)}"
      data-is_full_width="${bp_option_group.is_full_width}"
    >
      <div class="title">
        ${bp_option_group.ui_type_pc === BpOptionConstantS.UI_TYPE.CHECKBOX
          ? makeCheckBoxTypeHtml(bp_option_group, bp_options, selected_bp_option_id)
          : bp_option_group.additional_information !== null
            ? additionalInfoHtml(is_mobile, bp_option_group)
            : bp_option_group.ui_type_pc === BpOptionConstantS.UI_TYPE.TEXT_INPUT
              ? nfcInputHtml(is_mobile, bp_option_group)
              : bp_option_group['name' + G._en]}
      </div>
      ${bp_option_group.id == BpOptionUploadTypeS.UPLOAD_TYPE.bp_option_group_id
        ? BpOptionUploadTypeS.UPLOAD_TYPE.html.customSelectBoxHtml(
            selected_bp_option_id,
            !BpOptionUploadTypeS.UPLOAD_TYPE.option.editor.isReady([base_products_bp_option_group]),
            is_custom_editor,
          )
        : bp_option_group.ui_type_pc === BpOptionConstantS.UI_TYPE.CHECKBOX
          ? ''
          : !is_mobile && bp_option_group.ui_type_pc === BpOptionConstantS.UI_TYPE.FLEXI
            ? (G.mp?.maker?.flexiApi?.makeSizeGaugeHtml?.() ?? '')
            : bp_option_group.ui_type_pc === BpOptionConstantS.UI_TYPE.TEXT_INPUT
              ? new LinkToInput({
                  input_value: nfc_info?.input_value,
                  original_url: nfc_info?.original_url,
                  is_mobile,
                }).toHtmlSSR()
              : html` <div class="select_box">
                  ${strMap(
                    (bp_option) => html`
                      <div
                        data-is_public="${bp_option.is_public}"
                        class="option ${selected_bp_option_id === bp_option.id ? 'selected' : ''}"
                        data-id="${bp_option.id}"
                      >
                        ${bp_option['name' + G._en]}
                      </div>
                    `,
                  )(bp_options)}
                </div>`}

      <select
        name="${bp_option_group.id}"
        data-fx-json="${$dataStr(bp_option_group)}"
        data-id="${bp_option_group.id}"
        data-name="${bp_option_group.name}"
        data-name_en="${bp_option_group.name_en}"
        data-name_jp="${bp_option_group.name_jp}"
        ${setDisable(is_disabled, is_designed, is_lockable) ? 'disabled' : ''}
      >
        ${strMap((bp_option) => {
          // 20mm x 20mm 는 nfc에서 제외
          if (!UtilS.isEmpty(nfc_info) && bp_option.id == OPTION_ID_SIZE_20X20_MM) {
            return '';
          }
          return html`
            <option
              data-id="${bp_option.id}"
              data-fx-json="${$dataStr(bp_option)}"
              data-dev_name="${bp_option.dev_name}"
              data-is_public="${bp_option.is_public}"
              data-name="${bp_option.name}"
              data-name_en="${bp_option.name_en}"
              data-name_jp="${bp_option.name_jp}"
              data-no="${bp_option.no}"
              value="${bp_option.id}"
              ${selected_bp_option_id === bp_option.id ? 'selected' : ''}
            >
              ${getBpOptionName({ is_mobile, bp_option_group, is_designed, bp_option, flexi_size })}
            </option>
          `;
        })(bp_options)}
      </select>
    </div>
  `;
};

const getBpOptionName = ({ is_mobile, bp_option_group, is_designed, bp_option, flexi_size }) => {
  if (bp_option_group.ui_type_mobile === BpOptionConstantS.UI_TYPE.STATIC) {
    return flexi_size && is_designed
      ? `${Math.round(flexi_size.width)} x ${Math.round(flexi_size.height)} mm`
      : TT('flexi_maker::design_required');
  }
  return bp_option['name' + G._en];
};

export const getNeedFullWidthOptionGroup = (base_products_bp_option_groups) => {
  return go(
    base_products_bp_option_groups,
    pluck('_'),
    pluck('bp_option_group'),
    filter(
      (bp_option_group) =>
        bp_option_group.is_visibility &&
        bp_option_group.ui_type_mobile !== BpOptionConstantS.UI_TYPE.BUTTON &&
        bp_option_group.ui_type_mobile !== BpOptionConstantS.UI_TYPE.CHECKBOX &&
        bp_option_group.ui_type_mobile !== BpOptionConstantS.UI_TYPE.CUSTOM &&
        bp_option_group.ui_type_mobile !== BpOptionConstantS.UI_TYPE.TEXT_INPUT &&
        bp_option_group.ui_type_mobile !== BpOptionConstantS.UI_TYPE.HIDDEN,
    ),
    (bp_option_group) => {
      if (bp_option_group.length % 2 !== 0) {
        return last(bp_option_group);
      }
    },
  );
};
export const bpAllOptions = ({ product, selected_option_group, is_mobile, is_custom_editor }) => {
  const is_designed = BpOptionS.isDesigned(product);
  selected_option_group = selected_option_group || product?._?.selected_option_group;
  const nfc_info = selected_option_group?._?.nfc_info;
  const base_products_bp_option_groups = product._.base_product._.base_products_bp_option_groups;
  const is_vector_editor = VectorEditorConstantS.EDITOR_TYPES.includes(product._.base_product.maker_type);
  const is_flexi_editor = product._.base_product.maker_type === 'FLEXI';

  const full_width_option_group = getNeedFullWidthOptionGroup(base_products_bp_option_groups);

  return html`
    <div class="bp_option_groups" data-is_designed="${is_designed}">
      ${go(
        base_products_bp_option_groups,
        strMap((base_products_bp_option_group) => {
          const bp_option_group = base_products_bp_option_group._.bp_option_group;
          bp_option_group.is_full_width =
            bp_option_group.id === full_width_option_group?.id ||
            bp_option_group.ui_type_mobile === BpOptionConstantS.UI_TYPE.TEXT_INPUT;

          const bp_options = go(
            bp_option_group._.bp_options,
            filter((bo) => bo.is_public),
          );
          const selected_bp_option_id =
            go(
              bp_option_group._.bp_options,
              find(
                ({ id }) =>
                  selected_option_group?.bp_option_ids?.length &&
                  selected_option_group.bp_option_ids.includes(id),
              ),
              sel('id'),
            ) || base_products_bp_option_group.default_bp_option_id;

          return bpOptionGroupsHtmlArr({
            selected_bp_option_id,
            base_products_bp_option_group,
            bp_option_group,
            bp_options,
            is_designed,
            is_mobile,
            is_vector_editor,
            flexi_size: is_flexi_editor ? selected_option_group?.size : undefined,
            is_custom_editor,
            nfc_info,
          });
        }),
      )}
    </div>
  `;
};
